import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './postHeader.module.scss';
import SmartImage from '../smartImage/smartImage';

function PostHeader({
  postTitle = '',
  postDate = '',
  readingTime = '',
  reviewer = '',
  author = '',
  factChecker = '',
  thumbnail = null,
  keyTakeAways = {
    title: '',
    items: '',
  },
}) {
  return (
    <div className={styles.postHead}>
      <div className={styles.titleWrapper}>
        {postTitle && (
          <h1
            className={styles.title}
            itemType="https://schema.org/headline"
            itemProp="headline"
          >
            {postTitle}
          </h1>
        )}
        {(author || reviewer || factChecker) && (
          <div className={styles.authorDetailWrapper}>
            {author && (
              <div className={styles.authorDetail}>
                <span>Author</span>
                <span
                  data-testid="post-author"
                  itemType="https://schema.org/author"
                  itemProp="author"
                >
                  {author}
                </span>
              </div>
            )}
            {reviewer && (
              <div className={styles.authorDetail}>
                <span>Reviewed By</span>
                <span data-testid="post-reviewer">{reviewer}</span>
              </div>
            )}
            {factChecker && (
              <div className={styles.authorDetail}>
                <span>Fact Checked By</span>
                <span data-testid="post-checker">{factChecker}</span>
              </div>
            )}
          </div>
        )}
        {(postDate || readingTime) && (
          <div className={styles.details}>
            {postDate && (
              <span
                data-testid={postDate}
                itemType="https://schema.org/datePublished"
                itemProp="datePublished"
              >
                {postDate}
              </span>
            )}
            {readingTime && (
              <span
                data-testid={readingTime}
                itemType="https://schema.org/timeRequired"
                itemProp="timeRequired"
              >
                {readingTime}
              </span>
            )}
          </div>
        )}
      </div>
      {thumbnail && (
        <SmartImage
          itemType="https://schema.org/thumbnail"
          itemProp="thumbnail"
          src={thumbnail.src}
          alt={thumbnail.alt}
          className={styles.thumbnail}
          loading="lazy"
          width={thumbnail?.height ?? 180}
          height={thumbnail?.height ?? 180}
          quality={100}
          unoptimized
        />
      )}
      {keyTakeAways && (
        <div className={styles.takeAwayWrapper}>
          <div className={styles.takeAwayItems} data-testid="take-away">
            {parse(`${keyTakeAways}`)}
          </div>
        </div>
      )}
    </div>
  );
}
export default PostHeader;

PostHeader.propTypes = {
  postTitle: PropTypes.string,
  postDate: PropTypes.string,
  readingTime: PropTypes.string,
  reviewer: PropTypes.string,
  author: PropTypes.string,
  factChecker: PropTypes.string,
  thumbnail: PropTypes.object,
  keyTakeAways: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.string,
  }),
};
